/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import {
  ActiveRowInterface,
  ChargingPointProperties,
} from '../../interface/charging-point.interface';

interface TableSidePanel {
  deviceDetails: ChargingPointProperties | null;
  activeRow: ActiveRowInterface[];
}

// Initial state
const initialState: TableSidePanel = {
  deviceDetails: null,
  activeRow: [],
};

// Create the slice
export const tableSidePanelSlice = createSlice({
  name: 'table-side-panel',
  initialState,
  reducers: {
    /**
     * Update device management filters
     * @param state
     * @param action
     */
    updateSidePanelData: (state, action) => {
      const payload = { ...action.payload };
      if (payload.type === 'deviceId') {
        state.deviceDetails = payload.value;
      }
    },
    /**
     * Update device management filters
     * @param state
     * @param action
     */
    removeSidePanelData: (state, action) => {
      const payload = { ...action.payload };
      if (payload.type === 'deviceId') {
        state.deviceDetails = null;
      }
    },
    /**
     * Function for setting side panel data
     * @param state
     * @param action
     */
    setSidePanelData: (state, action) => {
      const existingIndex = state.activeRow.findIndex((item) => item.key === action.payload.key);

      if (existingIndex >= 0) {
        // If key exist, update the value
        state.activeRow[existingIndex].value = action.payload.value;
      } else {
        // If key does't exist, add new entry
        state.activeRow.push(action.payload);
      }
    },
    /**
     * Function for clear side panel date
     * @param state
     * @param action
     */
    clearSidePanelData: (state, action) => {
      const updatedValues = state.activeRow.filter((ar) => ar.key !== action.payload.key);
      state.activeRow = updatedValues;
    },
  },
});

// Export the actions
export const { updateSidePanelData, removeSidePanelData, setSidePanelData, clearSidePanelData } =
  tableSidePanelSlice.actions;

// Export the reducer
export default tableSidePanelSlice.reducer;
